import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GetWordCategoryResponse {
    event_category_idx: number;
    event_name: string;
}
export const useGetWordCategory = (): UseQueryResult<GetWordCategoryResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetWordCategoryResponse[], Error>({
        queryKey: ["getWordCategory"],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.common_get_word_category}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
